import { IDropdownOption } from "office-ui-fabric-react";
import { DecodeRegionalPartnership, DecodeSchoolType, getLocalAuthorityList, getRegionalPartnershipList, getSchoolList, WsDecodeLocalAuthority, WsDecodeSchool } from "./decode-data-hwb";
import { randomInRange } from "./decode-number-helpers";







interface DecodeDateRange {
  start: Date | null;
  end: Date | null;
}








// const regionalPartnershipList: DecodeRegionalPartnership[] = getRegionalPartnershipList();

const regionalPartnershipList: DecodeRegionalPartnership[] = [

  { id: 'swedbank-group',                   name: 'Swedbank Group'   },

  { id: 'savings-banks',                    name: 'Savings Banks'   },

  // { id: 'ams',                   name: 'Zone Americas (AMS)'   },
  // { id: 'eur',                   name: 'Zone Europe (EUR)'   },
  // { id: 'aoa',                   name: 'Zone Asia, Oceania & Africa (AOA)'   },

  // { id: 'csc',                   name: 'CSC'   },
  // { id: 'eas',                   name: 'EAS'   },
  // { id: 'gwe',                   name: 'GwE'   },
  // { id: 'mid_wales_partnership', name: 'Mid Wales Partnership'   },
  // { id: 'neath_port_talbot',     name: 'Neath Port Talbot'   },
  // { id: 'y_partneriaeth',        name: 'Y Partneriaeth'   },
];






const localAuthorityList: WsDecodeLocalAuthority[] = [

  { id: '',                   name: 'All'   },

  { id: 'swedbank-group-1',   name: 'Baltic Banking'   },

  { id: 'swedbank-group-2',   name: 'Swedish Banking'   },

  { id: 'swedbank-group-3',   name: 'Premium & Private Banking'   },

  { id: 'swedbank-group-4',   name: 'GBS&S'   },




  {id: 'savings-banks-1',    "name": "Bjursås Sparbank" },
  {id: 'savings-banks-2',    "name": "Dalslands Sparbank" },
  {id: 'savings-banks-3',    "name": "Ekeby Savings Bank" },
  {id: 'savings-banks-4',    "name": "Falkenbergs Sparbank" },
  {id: 'savings-banks-5',    "name": "Fryksdalens Sparbank" },
  {id: 'savings-banks-6',    "name": "Hälsinglands Sparbank" },
  {id: 'savings-banks-7',    "name": "Häradssparbanken Mönsterås" },
  {id: 'savings-banks-8',    "name": "Högsby Savings Bank" },
  {id: 'savings-banks-9',    "name": "Ivetofta Sparbank in Bromölla" },
  {id: 'savings-banks-10',    "name": "Kinda Ydre Sparbank" },
  {id: 'savings-banks-11',    "name": "Laholms Sparbank" },
  {id: 'savings-banks-12',    "name": "Lekebergs Sparbank" },
  {id: 'savings-banks-13',    "name": "Leksands Sparbank" },
  {id: 'savings-banks-14',    "name": "Lönneberga-Tuna-Vena Savings Bank" },
  {id: 'savings-banks-15',    "name": "Markaryd Savings Bank" },
  {id: 'savings-banks-16',    "name": "Mjöbäcks Sparbank" },
  {id: 'savings-banks-17',    "name": "Norrbärke Savings Bank" },
  {id: 'savings-banks-18',    "name": "Orusts Sparbank" },
  {id: 'savings-banks-19',    "name": "Sparbanken Göinge" },
  {id: 'savings-banks-20',    "name": "Sparbanken in Enköping" },
  {id: 'savings-banks-21',    "name": "Sparbanken in Karlshamn" },
  {id: 'savings-banks-22',    "name": "Sparbanken Lidköping" },
  {id: 'savings-banks-23',    "name": "Sparbanken Mälardalen" },
  {id: 'savings-banks-24',    "name": "Sparbanken Nord" },
  {id: 'savings-banks-25',    "name": "Sparbanken Skaraborg" },
  {id: 'savings-banks-26',    "name": "Sparbanken Skåne" },
  {id: 'savings-banks-27',    "name": "Sparbanken Spira" },
  {id: 'savings-banks-28',    "name": "Sparbanken Tranemo" },
  {id: 'savings-banks-29',    "name": "Sparbanken Tanum" },
  {id: 'savings-banks-30',    "name": "Sparbanken Sjuhärad" },
  {id: 'savings-banks-31',    "name": "Sörmlands Sparbank" },
  {id: 'savings-banks-32',    "name": "Södra Hestra Sparbank" },
  {id: 'savings-banks-33',    "name": "Sölvesborg-Mjällby Savings Bank" },
  {id: 'savings-banks-34',    "name": "Tidaholms Sparbank" },
  {id: 'savings-banks-35',    "name": "Tjörns Sparbank" },
  {id: 'savings-banks-36',    "name": "Ulricehamns Sparbank" },
  {id: 'savings-banks-37',    "name": "Valdemarsviks Sparbank" }
];

// getLocalAuthorityList();

// [
//   { id: '001', name: 'Blaenau Gwent'     },
//   { id: '002', name: 'Bridgend'          },
//   { id: '003', name: 'Caerphilly'        },
//   { id: '004', name: 'Cardiff'           },
//   { id: '005', name: 'Carmarthenshire'   },
//   { id: '006', name: 'Ceredigion'        },
//   { id: '007', name: 'Conwy'             },
//   { id: '008', name: 'Denbighshire'      },
//   { id: '009', name: 'Flintshire'        },
//   { id: '010', name: 'Gwynedd'           },
//   { id: '011', name: 'Isle of Anglesey'  },
//   { id: '012', name: 'Merthyr Tydfil'    },
//   { id: '013', name: 'Monmouthshire'     },
//   { id: '014', name: 'Neath Port Talbot' },
//   { id: '015', name: 'Newport'           },
//   { id: '016', name: 'Pembrokeshire'     },
//   { id: '017', name: 'Powys'             },
//   { id: '018', name: 'Rhondda Cynon Taf' },
//   { id: '019', name: 'Swansea'           },
//   { id: '020', name: 'Torfaen'           },
//   { id: '021', name: 'Vale of Glamorgan' },
//   { id: '022', name: 'Wrexham'           },
// ];










const schoolTypeList: DecodeSchoolType[] = [

  






  // { id: '1',   name: 'Nespresso'   },
  // { id: '2',   name: 'NHs (Nestlé Health Science)'   },
  // { id: '3',   name: 'Nestlé Waters'   },

  // { id: 'primary',   name: 'Primary Schools'   },
  // { id: 'middle',    name: 'Middle Schools'    },
  // { id: 'secondary', name: 'Secondary Schools' },
  // { id: 'college',   name: 'Colleges'          },
  // { id: 'aln',       name: 'ALN Schools'       },
];





const schoolList: WsDecodeSchool[] = getSchoolList();

// [

//   { id: '001001', regionalPartnershipId: '', localAuthorityId: '001', name: 'Blaenycwm Primary School' },
//   { id: '001002', regionalPartnershipId: '', localAuthorityId: '001', name: 'Willowtown Primary School' },

//   { id: '002001', regionalPartnershipId: '', localAuthorityId: '002', name: 'Brynteg School' },
//   { id: '002002', regionalPartnershipId: '', localAuthorityId: '002', name: 'Corneli Primary School' },

//   { id: '003001', regionalPartnershipId: '', localAuthorityId: '003', name: 'Ysgol Gyfun Cwm Rhymni' },

//   { id: '004001', regionalPartnershipId: '', localAuthorityId: '004', name: 'Cardiff High School' },
//   { id: '004002', regionalPartnershipId: '', localAuthorityId: '004', name: 'Cardiff Sixth Form College' },
//   { id: '004003', regionalPartnershipId: '', localAuthorityId: '004', name: 'Cardiff West Community High School' },
//   { id: '004004', regionalPartnershipId: '', localAuthorityId: '004', name: 'Eglwys Wen Primary School' },
//   { id: '004005', regionalPartnershipId: '', localAuthorityId: '004', name: 'Llanedeyrn High School' },
//   { id: '004006', regionalPartnershipId: '', localAuthorityId: '004', name: 'Michaelston Community College' },
//   { id: '004007', regionalPartnershipId: '', localAuthorityId: '004', name: `St Cadoc's Primary School` },

//   { id: '005001', regionalPartnershipId: '', localAuthorityId: '005', name: `Queen Elizabeth High School `},

// ];






const getRegionalPartnershipOptions = () => {
  const options: IDropdownOption[] = [];

  options.push({ key: '', text: 'All' });

  regionalPartnershipList.forEach((item) => {
    options.push({ key: item.id, text: `${item.name}` });
  });

  return options;
};




/** @agentsNote Business-unit IDs encode organisation membership; retain the shared All option for every organisation. */
const getLocalAuthorityOptions = (selectedRegionalPartnershipId: string | undefined): IDropdownOption[] => {
  return localAuthorityList
    .filter((item) => {
      return item.id === '' || !selectedRegionalPartnershipId || item.id.startsWith(`${selectedRegionalPartnershipId}-`);
    })
    .map((item) => {
      return { key: item.id, text: item.name };
    });
};





const getSchoolTypeOptions = (selectedRegionalPartnershipId: string | undefined) => {
  const options: IDropdownOption[] = [];

  options.push({ key: '', text: 'All' });

  schoolTypeList.forEach((item) => {

    if (selectedRegionalPartnershipId === '' || (selectedRegionalPartnershipId && item.id.startsWith(selectedRegionalPartnershipId))) {
      options.push({ key: item.id, text: `${item.name}` });
    }
  });

  return options;
};







const getSchoolOptions = (selectedRegionalPartnershipId: string | undefined, selectedLocalAuthorityId: string | undefined) => {
  const options: IDropdownOption[] = [];

  options.push({ key: '', text: 'All' });

  schoolList
    .filter((item) => {

      let filter = true;

      if (selectedRegionalPartnershipId) {
        if (item.regionalPartnershipId !== selectedRegionalPartnershipId) {
          filter = false;
        }
      }

      if (selectedLocalAuthorityId) {
        if (item.localAuthorityId !== selectedLocalAuthorityId) {
          filter = false;
        }
      }

      return filter;

    })
    .forEach((item) => {
      options.push({ key: item.id, text: `${item.name} (${item.id})` });
    });

  return options;
};




// const adjustmentFactors: { [ key: string ]: number[] } = {

//   '001001': [ 0.75, 0.30, 0.40, 0.30, 0.88, 0.40 ],
//   '001002': [ 0.80 ],

//   '002001': [ 0.70, 0.60, 0.20, 0.90, 0.50, 0.95 ],
//   '002002': [ 0.85 ],

//   '003001': [ 0.90, 0.40, 0.50, 0.60, 0.50, 0.70 ],

//   '004001': [ 0.50, 0.40, 0.77, 0.71, 0.90, 0.50 ],
//   '004002': [ 0.80, 0.50, 0.20, 0.35, 0.55, 0.71 ],
//   '004003': [ 0.70, 0.20, 0.90, 0.88, 0.33, 0.90 ],
//   '004004': [ 0.60 ],
//   '004005': [ 0.75 ],
//   '004006': [ 0.85 ],
//   '004007': [ 0.90 ],

//   '005001': [ 0.80, 0.60, 0.95, 0.44, 0.33, 0.70 ]

// };

























const getAdjustmentFactor = (filterId: string, index: number): number =>{

  // const value = adjustmentFactors[filterId];

  const v1 = randomInRange(`${filterId}-1`, 0.50, 0.95, 0.05);
  const v2 = randomInRange(`${filterId}-1`, 0.50, 0.95, 0.05);
  const v3 = randomInRange(`${filterId}-1`, 0.50, 0.95, 0.05);
  const v4 = randomInRange(`${filterId}-1`, 0.50, 0.95, 0.05);
  const v5 = randomInRange(`${filterId}-1`, 0.50, 0.95, 0.05);
  const v6 = randomInRange(`${filterId}-1`, 0.50, 0.95, 0.05);

  const value = [ v1, v2, v3, v4, v5, v6 ];

  if (value) {

    if (index > 0 && value[index]) {
      return value[index];
    } else {
      return value[0];
    }

  } else {
    return 1;
  }
};





















export {

  localAuthorityList,

  getRegionalPartnershipOptions,

  getLocalAuthorityOptions,

  getSchoolTypeOptions,
  getSchoolOptions,
  getAdjustmentFactor
};




export type {
  DecodeDateRange
};
